export const monitoring = {

  index: {
    title: 'Pemantauan kampanye'
  },

  operators: {
    topic: 'Operators',
    count_active: 'Percakapan',
    count_connected: 'Terhubung',
    state: {
      disconnected: 'Terputus',
      connected: 'Percakapan'
    },
    disconnected: {
      state: 'Terputus'
    },
    connected: {
      state: 'Terhubung'
    }
  },

  rooms: {
    topic: 'Kamar',
    empty: 'Kamar akan menghilang setelah',
    state: {
      ready: 'Siap',
      busy: 'Sibuk',
      pending: 'Operator terputus',
      empty: 'Ruangan kosong'
    }
  },

  tasks: {
    topic: 'Tugas',
    all: 'Total',
    pending: {
      state: 'Tunda'
    },
    connected: {
      state: 'Tunda operator'
    },
    dialing: {
      state: 'Sambungan'
    },
    active: {
      state: 'Percakapan'
    },
    processing: {
      state: 'Adalah proses'
    },
    canceled: {
      state: 'Dibatalkan'
    },
    checking: {
      state: 'Memeriksa penjawab'
    }
  },

  campaign: {
    topic: 'Informasi kampanye',
    type: 'Tipe',
    avg_task: 'Durasi tugas rata-rata'
  },

  field: {
    id: 'ID',
    number: 'Nomor',
    caller_id: 'Caller ID',
    priority: 'Prioritas',
    attempts: 'Percobaan',
    strategy: 'Posisi dalam strategi',
    start: 'Dibuat pada',
    status: 'Status',
    login: 'Login',
    avg_time: 'Waktu dial-up rata-rata',
    sec: 'det',
    campaign: 'kampanye',
    calc: 'ASR',
    drop: 'Setel ulang ASR',
    last_attempt: 'Percobaan terakhir',
    next_attempt: 'Percobaan berikutnya',
    created_at: 'Perintah dibuat di',
    lead_date: 'Tugas dibuat di'
  },
  
  state: {
    title: 'Status',
    success: 'Berhasil',
    processing: 'Adalah proses',
    canceled: 'Dibatalkan',
    pending: 'Tunda',
    fail: 'Gagal'
  },

  button: {
    create: 'Pemantauan'
  },

  type: {
    progressive: 'Progresif',
    predictive: 'Prediktif'
  },

  modal: {
    create: 'Buat tugas'
  }

}